import axios from "../interceptors/axios";

// Função para criar um capítulo de um livro
export const createChapter = async (data) => {
  const payload = {
    project_id: data.project_id,
    title: data.title,
    content: data.content,
    published: data.published,
  };

  if (data.scheduled_at) {
    payload.scheduled_at = data.scheduled_at;
  }

  try {
    const response = await axios.post("/api/books", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error.response
      ? error.response.data
      : { success: false, message: "Error occurred" };
  }
};

// Função para listar capítulos de um livro
export const listChapters = async (bookId, published = null) => {
  try {
    const url =
      published !== null
        ? `/api/books/${bookId}?published=${published}`
        : `/api/books/${bookId}`;

    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data.chapters;
  } catch (error) {
    return error.response
      ? error.response.data
      : { success: false, message: "Error occurred" };
  }
};

// Função para atualizar um capítulo de um livro
export const updateChapter = async (chapterId, data) => {
  const payload = {
    title: data.title,
    content: data.content,
    published: data.published,
    scheduled_at: data.scheduled_at || null,
  };

  try {
    const response = await axios.put(`/api/books/${chapterId}`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error.response
      ? error.response.data
      : { success: false, message: "Error occurred" };
  }
};
